import React from 'react'; import PropTypes from 'prop-types';
import classnames from 'classnames';

const subscriptionStatus = [
    { name: 'PendingSystemActivation', pictureUrl: '/icons/product_status_icons/skal_activeres_s_ic.svg', translation: 'Skal aktiveres' },
    { name: 'Active', pictureUrl: '/icons/product_status_icons/active_s_ic.svg', translation: 'Active' },
    { name: 'Cancelled', pictureUrl: '/icons/product_status_icons/canceled_s_ic.svg', translation: 'Canceled' },
    { name: 'Disconnected', pictureUrl: '/icons/product_status_icons/disconnected_s_ic.svg', translation: 'Disconnected' },
    { name: 'Frozen', pictureUrl: '/icons/product_status_icons/frosset_s_ic.svg', translation: 'Frosset' },
    { name: 'PendingDateActivation', pictureUrl: '/icons/product_status_icons/senare_activering_s_ic.svg', translation: 'Senare aktivering' },
    { name: 'PendingDisconnection', pictureUrl: '/icons/product_status_icons/skal_disconnectas_s_ic.svg', translation: 'Scal disconnectas' },
    { name: 'WriteOff', pictureUrl: '/icons/product_status_icons/write_of_s_ic.svg', translation: 'Write off' },
    { name: 'PendingCancellation', pictureUrl: '/icons/product_status_icons/skal_kanselleres_s_ic.svg', translation: 'Scal kanselleres' },
    { name: 'PendingFreeze', pictureUrl: '/icons/product_status_icons/skal_fryses_s_ic.svg', translation: 'Skal fryses' },
    { name: 'NotRelevant', pictureUrl: '/icons/product_status_icons/data_error_ic.svg', translation: 'ICC data error - no status' }
]

const getStatusSettings = status => {
    return subscriptionStatus.find(item => item.name === status);
}

const SoftwareProductsTable = ({ softwareProductsList, tableName, className, editMode = false }) => {
    const productTableClass = classnames('productTable', className);
    const hasSoftwareProducts = softwareProductsList && softwareProductsList.length > 0;
    return (
        <div>
            <div className={productTableClass}>
                <table>
                    <thead>
                        <tr className="contentRow">
                            <th className="col-xs-7 fontSizeBase">{tableName}:</th>
                            <th className="col-xs-2 fontSizeSmall text-center">Status</th>
                            {editMode &&
                                <th className="col-xs-2 fontSizeSmall text-center hide"></th>
                            }
                            <th className="col-xs-1 fontSizeSmall text-center"></th>
                        </tr>

                    </thead>
                    <tbody>
                        {hasSoftwareProducts && softwareProductsList.map((subscription, i) => {
                            let statusSettings = getStatusSettings(subscription.status);
                            return (
                                <tr key={i} className="contentRow">
                                    <td className=" row-fluid col-xs-7 productBoxContent">
                                        <div className="row-fluid productBoxLabel">
                                            {subscription.name}
                                        </div>
                                        <div className="row-fluid fontSizeSmall">
                                            {subscription.contractEndDate}
                                        </div>
                                    </td>
                                    <td className="col-xs-2 center">
                                        <img src={statusSettings.pictureUrl} className="icon" alt={statusSettings.translation} title={statusSettings.translation} />
                                    </td>
                                    {editMode
                                        &&
                                        <td className="col-xs-2 hide">
                                            <img src="/icons/prod_subsc/cancel_ic.svg" className="icon" alt="Add/Remove" />
                                        </td>
                                    }
                                    <td className="col-xs-1"></td>
                                </tr>
                            )
                        })
                        }
                        {!hasSoftwareProducts &&
                            <tr>
                                <td>
                                    <div className="col-xs-12 fontSizeBase ">Ingen produkter</div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default SoftwareProductsTable;